exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nav {\r\n  /*height: 50px;*/\r\n}\r\n.bg-tp {\r\n  background-color: #2c3e50 !important;\r\n  color: white !important;\r\n}\r\n.logo-png {\r\n  padding: 5px;\r\n  height: 40px;\r\n}\r\n.nav-logo {\r\n  width: 40px;\r\n  height: 40px;\r\n}\r\n.select {\r\n  cursor: pointer;\r\n}\r\n@media (max-width: 576px) {\r\n  .navbar-brand {\r\n    margin-bottom: 0;\r\n  }\r\n  .collapse {\r\n    margin-top: 0;\r\n    background-color: rgba(255, 255, 255, 0.562);\r\n  }\r\n  .navbar-text {\r\n    padding: 0 !important;\r\n  }\r\n  .side-icon {\r\n    display: inline-block !important;\r\n  }\r\n}\r\n\r\n\r\n.students {\r\n  display: block; /* Hide by default */\r\n}\r\n\r\n@media (max-width: 769px) {\r\n  .students {\r\n    display: none; /* Show only when screen width is 769px or less */\r\n  }\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/navbar/navbar.component.css
// module id = ../../../../../src/app/parent/dashboard/navbar/navbar.component.css
// module chunks = main